import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    exportCreationError:
      'An error occurred while creating the accounting export. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    nextButton: 'Send my export',
    title: 'What do you want to include?',
  },
  fr: {
    exportCreationError:
      'Une erreur est survenue lors de la création de l’export comptable. Merci de réessayer à nouveau dans quelques minutes et n’hésitez pas à contacter le support si le problème persiste.',
    nextButton: 'Envoyer mon export',
    title: 'Que souhaitez-vous inclure\xa0?',
  },
});

export default locales;
